<div class="container-fluid">
  <div class="row">
    <img
      class="imgBack cursor-pointer"
      (click)="goBack()"
      src="assets/img/backbtn.png"
    />
  </div>
  <app-fitness-member-basic-details
    [memberDetail]="memberId"
    [currentStep]="currentStep"
    [totalSteps]="totalSteps"
    [isEditMode]="isEditMode"
    [isCurrentStepValid]="isCurrentStepValid()"
    (nextStepClicked)="nextStep()"
    (createPlanClicked)="createPlan()"
  ></app-fitness-member-basic-details>
  <hr class="mt-2" />

  <div class="col-md-12 mt-5">
    <!-- Step 1: Date Range Selection -->
    <div *ngIf="currentStep === 1" class="activeTabContent">
      <div class="mb-3">
        <h4 class="section-header">Select Date</h4>
        <p class="section-description">
          {{
            isEditMode
              ? "Modify the date range for your fitness plan (existing exercises will be preserved for matching dates)"
              : "Select the start and end date of the Fitness Planner"
          }}
        </p>
        <div *ngIf="isEditMode" class="alert alert-info edit-mode-alert">
          <i class="fas fa-info-circle"></i>
          <strong>Edit Mode:</strong> You can adjust the date range. Existing
          exercises will be loaded for dates that have data.
        </div>
      </div>

      <div class="date-pickers-container mt-4">
        <div class="date-picker-item">
          <div class="date-input-wrapper mb-3">
            <input
              type="text"
              class="form-control"
              [matDatepicker]="startPicker"
              [(ngModel)]="startDate"
              (dateChange)="onStartDateChange($event.value)"
              [min]="minDate"
              placeholder="Select Start Date"
              readonly
            />
            <mat-icon
              class="calendar-icon cursor-pointer"
              (click)="startPicker.open()"
              >calendar_today</mat-icon
            >
            <mat-datepicker #startPicker></mat-datepicker>
          </div>
          <small class="text-muted">MM/DD/YYYY</small>
        </div>

        <div class="date-picker-item">
          <div class="date-input-wrapper mb-3">
            <input
              type="text"
              class="form-control"
              [matDatepicker]="endPicker"
              [(ngModel)]="endDate"
              (dateChange)="onEndDateChange($event.value)"
              [min]="getMinEndDate()"
              placeholder="Select End Date"
              readonly
            />
            <mat-icon
              class="calendar-icon cursor-pointer"
              (click)="endPicker.open()"
              >calendar_today</mat-icon
            >
            <mat-datepicker #endPicker></mat-datepicker>
          </div>
          <small class="text-muted">MM/DD/YYYY</small>
        </div>


        <!-- Template Selection Dropdown - Inline with date pickers -->
        <div class="template-picker-item">
          <div class="template-input-wrapper mb-3">
            <select
              class="form-control template-select"
              [(ngModel)]="selectedTemplateId"
              (ngModelChange)="onTemplateChange($event)"
              [disabled]="isLoadingTemplates"
            >
              <option value="" *ngIf="!isLoadingTemplates">
                Select Template (Optional)
              </option>
              <option value="" *ngIf="isLoadingTemplates">
                Loading templates...
              </option>
              <option
                *ngFor="let template of availableTemplates"
                [value]="template.id"
              >
                {{ template.name }}
              </option>
            </select>
            <mat-icon class="template-icon">assignment</mat-icon>
          </div>
          <small class="text-muted"
            >Choose a template to auto-populate exercises</small
          >
        </div>
      </div>

      <div class="row mt-3" *ngIf="startDate && endDate">
        <div class="col-md-12">
          <div class="alert alert-info plan-duration-alert">
            <strong>Plan Duration:</strong> {{ getDurationDisplay() }}
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: Date List Accordion -->
    <div *ngIf="currentStep === 2" class="activeTabContent">
      <div class="mb-4">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="section-header mb-0">Plan Schedule</h4>
          <!-- Fitness Plan Name Input Field - In the red marked area next to header -->
          <div class="fitness-plan-name-item">
            <div class="fitness-plan-name-input-wrapper">
              <input
                type="text"
                class="form-control fitness-plan-name-input"
                [(ngModel)]="fitnessPlanName"
                placeholder="Enter Fitness Plan Name"
                [class.is-invalid]="!fitnessPlanName || fitnessPlanName.trim() === ''"
              />
            </div>
            <small 
              class="fitness-plan-name-help-text"
              [class.text-muted]="fitnessPlanName && fitnessPlanName.trim() !== ''"
              *ngIf="fitnessPlanName && fitnessPlanName.trim() !== ''"
            >
              Give your fitness plan a name
            </small>
          </div>
        </div>
        <p class="section-description">
          Review and configure exercises for each day of your fitness plan
        </p>
      </div>


      <!-- Plan Summary -->
      <div class="plan-summary mb-4 plan-summary-container">
        <div class="plan-summary-inline">
          <span class="plan-summary-item">
            <strong class="plan-summary-info">Duration:</strong>
            {{ getDurationDisplay() }}
          </span>
          <span class="plan-summary-item">
            <strong class="plan-summary-info">Start Date:</strong>
            {{ startDate | date : "MMMM d, y" }}
          </span>
          <span class="plan-summary-item">
            <strong class="plan-summary-info">End Date:</strong>
            {{ endDate | date : "MMMM d, y" }}
          </span>
        </div>
      </div>

      <!-- Date Accordion List -->
      <div class="date-accordion-container" *ngIf="dateList.length > 0">
        <div
          class="accordion-item mb-3 accordion-item-container"
          [ngClass]="{ 'past-date': isDateNonEditable(dateItem.date) }"
          *ngFor="let dateItem of dateList; let i = index"
        >
          <!-- Accordion Header with 4-part layout -->
          <div
            class="accordion-header accordion-header-4part"
            [ngClass]="{ 'past-date-header': isDateNonEditable(dateItem.date) }"
            (click)="toggleAccordion(i)"
          >
            <!-- Part 1: Date and Day (2/12 width) -->
            <div class="date-section">
              <h6>
                Day {{ i + 1 }} - {{ dateItem.formattedDate }}
                <span
                  *ngIf="isDateNonEditable(dateItem.date)"
                  class="text-muted ml-2"
                  [title]="
                    isToday(dateItem.date)
                      ? 'Current date - read only'
                      : 'Past date - read only'
                  "
                >
                  🔒
                </span>
              </h6>
              <div class="date-day-name">
                <small>
                  {{ dateItem.dayName }}
                  <span
                    *ngIf="isDateNonEditable(dateItem.date)"
                    class="text-muted ml-1"
                  >
                    ({{
                      isToday(dateItem.date)
                        ? "Current date - read only"
                        : "Read Only"
                    }})
                  </span>
                </small>
              </div>
            </div>

            <!-- Part 2: Completion Status (1/12 width) -->
            <div class="completion-section">
              <span
                *ngIf="!dateItem.isRestDay && getTotalSetsCount(i) > 0"
                class="completion-status"
              >
                <mat-icon
                  *ngIf="hasCompletedExercises(i)"
                  class="completion-icon"
                  >check_circle</mat-icon
                >
                <small
                  class="completion-text"
                  [ngClass]="hasCompletedExercises(i) ? 'completed' : 'default'"
                >
                  {{ getCompletedSetsCount(i) }}/{{ getTotalSetsCount(i) }} sets
                </small>
              </span>
              <span *ngIf="dateItem.isRestDay" class="completion-text default">
                Rest Day
              </span>
              <span
                *ngIf="!dateItem.isRestDay && getTotalSetsCount(i) === 0"
                class="completion-text default"
              >
                No exercises
              </span>
            </div>

            <!-- Part 3: Workout Day Button (3/12 width) -->
            <div class="button-section">
              <div class="d-flex align-items-center gap-2">
                <button
                  class="btn btn-sm workout-day-btn"
                  [ngClass]="dateItem.isRestDay ? 'rest' : 'workout'"
                  [disabled]="isDateNonEditable(dateItem.date)"
                  (click)="toggleDateRestDay(i); $event.stopPropagation()"
                >
                  {{ dateItem.isRestDay ? "Rest Day" : "Workout Day" }}
                </button>

                <!-- Undo button - only show if rest day can be undone -->
                <button
                  *ngIf="canUndoRestDayConversion(i)"
                  class="btn btn-sm btn-outline-warning"
                  [disabled]="isDateNonEditable(dateItem.date)"
                  (click)="undoRestDayConversion(i); $event.stopPropagation()"
                  title="Restore exercises"
                >
                  <i class="fas fa-undo-alt"></i>
                </button>

                <!-- Apply to Upcoming Weekdays button -->
                <button
                  *ngIf="!dateItem.isRestDay && hasUpcomingSameWeekdays(i)"
                  class="btn btn-sm btn-outline-info"
                  [disabled]="isDateNonEditable(dateItem.date)"
                  (click)="applyToUpcomingWeekdays(i); $event.stopPropagation()"
                  title="Apply these exercises to all upcoming {{
                    getWeekdayName(dateItem.date)
                  }}s"
                >
                  <i class="fas fa-copy"></i> Apply to
                  {{ getWeekdayName(dateItem.date) }}s
                </button>
              </div>

              <small class="button-help-text">
                <span *ngIf="!isDateNonEditable(dateItem.date)">
                  <span *ngIf="!canUndoRestDayConversion(i)">
                    Click to mark as
                    {{ dateItem.isRestDay ? "Workout Day" : "Rest Day" }}
                    <span
                      *ngIf="hasUpcomingSameWeekdays(i) && !dateItem.isRestDay"
                      class="text-info"
                    >
                      • Use "Apply to {{ getWeekdayName(dateItem.date) }}s" to
                      copy exercises to upcoming
                      {{ getWeekdayName(dateItem.date) }}s
                    </span>
                  </span>
                  <span
                    *ngIf="canUndoRestDayConversion(i)"
                    class="text-warning"
                  >
                    Exercises will be removed - click undo to restore
                  </span>
                </span>
                <span
                  *ngIf="isDateNonEditable(dateItem.date)"
                  class="text-muted"
                >
                  {{
                    isToday(dateItem.date)
                      ? "Current date - read only"
                      : "Past date - read only"
                  }}
                </span>
              </small>
            </div>

            <!-- Part 4: Exercise Counts and Expand Icon (6/12 width) -->
            <div class="exercise-info-section">
              <!-- Exercise Count Inline -->
              <div *ngIf="!dateItem.isRestDay" class="exercise-count-container">
                <span class="exercise-count-main">
                  {{
                    getSectionExerciseCount(i, "warmup") +
                      getSectionExerciseCount(i, "main") +
                      getSectionExerciseCount(i, "cooldown")
                  }}
                  exercise{{
                    getSectionExerciseCount(i, "warmup") +
                      getSectionExerciseCount(i, "main") +
                      getSectionExerciseCount(i, "cooldown") !==
                    1
                      ? "s"
                      : ""
                  }}
                </span>
                <small class="exercise-count-sub">
                  ({{ getSectionExerciseCount(i, "warmup") }} warm-up,
                  {{ getSectionExerciseCount(i, "main") }} main,
                  {{ getSectionExerciseCount(i, "cooldown") }} cool-down)
                </small>
              </div>

              <span *ngIf="dateItem.isRestDay" class="no-exercises-text">
                No exercises
              </span>

              <!-- Expand/Collapse Icon -->
              <mat-icon
                class="expand-icon"
                [ngClass]="dateItem.isExpanded ? 'expanded' : 'collapsed'"
              >
                expand_more
              </mat-icon>
            </div>
          </div>

          <!-- Accordion Content -->
          <div
            class="accordion-content accordion-content-container"
            *ngIf="dateItem.isExpanded"
          >
            <!-- Rest Day Message -->
            <div *ngIf="dateItem.isRestDay" class="rest-day-container">
              <mat-icon class="rest-day-icon">bed</mat-icon>
              <p class="rest-day-title">Rest Day</p>
              <p class="rest-day-subtitle">
                No exercises scheduled for this day
              </p>
            </div>

            <!-- Exercise Configuration -->
            <div *ngIf="!dateItem.isRestDay" class="exercise-config">
              <!-- Exercise Sections Loop -->
              <div
                class="exercise-section mb-4"
                *ngFor="let section of exerciseSections"
              >
                <h6
                  class="exercise-section-header"
                  [style.color]="section.color"
                  [style.border-left-color]="section.color"
                >
                  {{ section.title }}
                </h6>
                <div
                  class="exercise-container mb-3 exercise-container-styled"
                  [ngClass]="{
                    'marked-for-deletion': isExerciseMarkedForDeletion(exercise)
                  }"
                  *ngFor="
                    let exercise of getExercisesBySection(i, section.key);
                    let j = index
                  "
                  [style.background]="section.background"
                  [style.border-color]="section.border"
                >
                  <!-- 3-6-3 Grid Layout -->
                  <div class="exercise-grid-row exercise-grid-layout">
                    <!-- Grid 1: Exercise Dropdown (3fr) -->
                    <div class="exercise-dropdown-grid">
                      <select
                        class="form-control"
                        [(ngModel)]="exercise.exercise"
                        [disabled]="
                          isDateNonEditable(dateItem.date) ||
                          isExerciseMarkedForDeletion(exercise)
                        "
                      >
                        <option value="" disabled>
                          Select
                          {{
                            section.key === "warmup"
                              ? "Warm Up Exercise"
                              : section.key === "cooldown"
                              ? "Cool Down Exercise"
                              : "Main Exercise"
                          }}
                        </option>
                        <option
                          *ngFor="let availableExercise of availableExercises"
                          [value]="availableExercise"
                        >
                          {{ availableExercise }}
                        </option>
                      </select>
                    </div>

                    <!-- Grid 2: Sets Container (6fr) -->
                    <div class="sets-grid">
                      <!-- Set 1 -->
                      <div *ngIf="exercise.sets.length > 0" class="set-row">
                        <span class="set-label">Set 1:</span>

                        <!-- Set 1 Reps Input -->
                        <div class="set-input-container">
                          <input
                            type="number"
                            class="form-control small-input reps-input set-input"
                            [(ngModel)]="exercise.sets[0].reps"
                            placeholder="Reps"
                            min="1"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                          />
                        </div>

                        <!-- Set 1 Time Input - Separate MM and SS fields -->
                        <div class="set-input-container time-inputs-container">
                          <div class="time-field-group">
                            <input
                              type="number"
                              class="form-control small-input time-minutes-input set-input"
                              [(ngModel)]="exercise.sets[0].timeMinutes"
                              placeholder="MM"
                              min="0"
                              max="99"
                              title="Enter minutes (0-99)"
                              [disabled]="
                                isDateNonEditable(dateItem.date) ||
                                isExerciseMarkedForDeletion(exercise)
                              "
                              (input)="
                                updateTimeFromSeparateFields(exercise.sets[0])
                              "
                              (blur)="
                                validateMinutesInput($event, exercise.sets[0])
                              "
                            />
                            <span class="time-separator">:</span>
                            <input
                              type="number"
                              class="form-control small-input time-seconds-input set-input"
                              [(ngModel)]="exercise.sets[0].timeSeconds"
                              placeholder="SS"
                              min="0"
                              max="59"
                              title="Enter seconds (0-59)"
                              [disabled]="
                                isDateNonEditable(dateItem.date) ||
                                isExerciseMarkedForDeletion(exercise)
                              "
                              (input)="
                                updateTimeFromSeparateFields(exercise.sets[0])
                              "
                              (blur)="
                                validateSecondsInput($event, exercise.sets[0])
                              "
                            />
                          </div>
                        </div>

                        <!-- Set 1 Weights Input -->
                        <div class="set-input-container">
                          <input
                            type="number"
                            class="form-control small-input weights-input set-input"
                            [(ngModel)]="exercise.sets[0].weights"
                            placeholder="Weight (lb)"
                            min="0"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                          />
                        </div>

                        <!-- Restore Button for Set 1 (only when template is selected and allotment exists) -->
                        <div
                          *ngIf="shouldShowRestoreButton(exercise, i) && exercise.sets.length === 1"
                          class="restore-button-container"
                        >
                          <button
                            class="btn btn-sm restore-btn"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                            (click)="restoreExerciseData(exercise, i)"
                            title="Restore previous exercise data"
                          >
                            <mat-icon class="restore-icon">restore</mat-icon>
                            Restore
                          </button>
                        </div>

                        <!-- Add Set Button for Set 1 (only when there's only 1 set) -->
                        <div
                          *ngIf="exercise.sets.length === 1"
                          class="set-buttons-container"
                        >
                          <button
                            class="btn btn-sm add-set-btn"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                            (click)="addSetToExercise(i, exercise.id)"
                          >
                            + Set
                          </button>
                        </div>

                        <!-- Completed Status -->
                        <div
                          *ngIf="isSetCompleted(exercise.sets[0])"
                          class="set-completed-status"
                        >
                          <mat-icon class="set-icon">check_circle</mat-icon>
                          <span class="set-completed-text">Completed</span>
                        </div>
                      </div>

                      <!-- Additional Sets (Set 2, 3, etc.) -->
                      <div
                        class="set-row"
                        *ngFor="
                          let set of exercise.sets.slice(1);
                          let k = index
                        "
                      >
                        <!-- Set Number -->
                        <span class="set-label">Set {{ set.setNumber }}:</span>

                        <!-- Reps Input -->
                        <div class="set-input-container">
                          <input
                            type="number"
                            class="form-control small-input reps-input set-input"
                            [(ngModel)]="set.reps"
                            placeholder="Reps"
                            min="1"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                          />
                        </div>

                        <!-- Time Input - Separate MM and SS fields -->
                        <div class="set-input-container time-inputs-container">
                          <div class="time-field-group">
                            <input
                              type="number"
                              class="form-control small-input time-minutes-input set-input"
                              [(ngModel)]="set.timeMinutes"
                              placeholder="MM"
                              min="0"
                              max="99"
                              title="Enter minutes (0-99)"
                              [disabled]="
                                isDateNonEditable(dateItem.date) ||
                                isExerciseMarkedForDeletion(exercise)
                              "
                              (input)="updateTimeFromSeparateFields(set)"
                              (blur)="validateMinutesInput($event, set)"
                            />
                            <span class="time-separator">:</span>
                            <input
                              type="number"
                              class="form-control small-input time-seconds-input set-input"
                              [(ngModel)]="set.timeSeconds"
                              placeholder="SS"
                              min="0"
                              max="59"
                              title="Enter seconds (0-59)"
                              [disabled]="
                                isDateNonEditable(dateItem.date) ||
                                isExerciseMarkedForDeletion(exercise)
                              "
                              (input)="updateTimeFromSeparateFields(set)"
                              (blur)="validateSecondsInput($event, set)"
                            />
                          </div>
                        </div>

                        <!-- Weights Input -->
                        <div class="set-input-container">
                          <input
                            type="number"
                            class="form-control small-input weights-input set-input"
                            [(ngModel)]="set.weights"
                            placeholder="Weight (lb)"
                            min="0"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                          />
                        </div>

                        <!-- Restore Button for Additional Sets (only when template is selected and allotment exists) -->
                        <div
                          *ngIf="shouldShowRestoreButton(exercise, i) && k === exercise.sets.slice(1).length - 1"
                          class="restore-button-container"
                        >
                          <button
                            class="btn btn-sm restore-btn"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                            (click)="restoreExerciseData(exercise, i)"
                            title="Restore previous exercise data"
                          >
                            <mat-icon class="restore-icon">restore</mat-icon>
                            Restore
                          </button>
                        </div>

                        <!-- Set Action Buttons -->
                        <div class="set-buttons-flex">
                          <!-- Add Set Button (only on last set) -->
                          <button
                            class="btn btn-sm add-set-btn"
                            *ngIf="k === exercise.sets.slice(1).length - 1"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                            (click)="addSetToExercise(i, exercise.id)"
                          >
                            + Set
                          </button>

                          <!-- Remove Set Button -->
                          <button
                            class="btn btn-sm remove-set-btn"
                            [disabled]="
                              isDateNonEditable(dateItem.date) ||
                              isExerciseMarkedForDeletion(exercise)
                            "
                            (click)="
                              removeSetFromExercise(i, exercise.id, k + 1)
                            "
                          >
                            - Set
                          </button>
                        </div>

                        <!-- Completed Status -->
                        <div
                          *ngIf="isSetCompleted(set)"
                          class="set-completed-status"
                        >
                          <mat-icon class="set-icon">check_circle</mat-icon>
                          <span class="set-completed-text">Completed</span>
                        </div>
                      </div>
                    </div>

                    <!-- Grid 3: Exercise Action Buttons (3fr) -->
                    <div class="exercise-actions-grid">
                      <div class="exercise-actions exercise-actions-container">
                        <!-- Marked for Deletion Badge -->
                        <span
                          *ngIf="isExerciseMarkedForDeletion(exercise)"
                          class="marked-for-deletion-badge"
                        >
                          MARKED FOR DELETION
                        </span>

                        <!-- Add Exercise Button -->
                        <button
                          class="btn btn-sm add-exercise-btn"
                          *ngIf="
                            j ===
                            getExercisesBySection(i, section.key).length - 1
                          "
                          [disabled]="isDateNonEditable(dateItem.date)"
                          (click)="addExerciseToDate(i, section.key)"
                          [style.background]="section.buttonBg"
                        >
                          <mat-icon class="add-exercise-icon">add</mat-icon>
                          {{
                            section.key === "warmup"
                              ? "Warmup"
                              : section.key === "cooldown"
                              ? "Cooldown"
                              : "Main"
                          }}
                        </button>

                        <!-- Remove Exercise Button -->
                        <button
                          class="btn btn-sm remove-exercise-btn"
                          [ngClass]="{
                            existing:
                              hasExistingExercise(exercise) &&
                              !isExerciseMarkedForDeletion(exercise),
                            clear: !hasExistingExercise(exercise),
                            'marked-for-deletion':
                              isExerciseMarkedForDeletion(exercise),
                            'undo-deletion':
                              isExerciseMarkedForDeletion(exercise)
                          }"
                          [disabled]="isDateNonEditable(dateItem.date)"
                          (click)="removeExerciseFromDate(i, exercise.id)"
                          [title]="
                            isExerciseMarkedForDeletion(exercise)
                              ? 'Restore exercise'
                              : hasExistingExercise(exercise)
                              ? 'Mark exercise for deletion'
                              : 'Clear exercise'
                          "
                        >
                          <mat-icon class="remove-exercise-icon">
                            {{
                              isExerciseMarkedForDeletion(exercise)
                                ? "undo"
                                : hasExistingExercise(exercise)
                                ? "delete"
                                : "clear"
                            }}
                          </mat-icon>
                          {{
                            isExerciseMarkedForDeletion(exercise)
                              ? "Restore"
                              : hasExistingExercise(exercise)
                              ? "Delete"
                              : "Clear"
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Add Exercise Button when no exercises exist for this section -->
                <div
                  *ngIf="getExercisesBySection(i, section.key).length === 0"
                  class="add-exercise-empty"
                >
                  <button
                    class="btn btn-sm add-exercise-empty-btn"
                    [disabled]="isDateNonEditable(dateItem.date)"
                    (click)="addExerciseToDate(i, section.key)"
                    [style.background]="section.buttonBg"
                    [style.color]="'white'"
                  >
                    <mat-icon class="add-exercise-icon">add</mat-icon>
                    Add {{ section.key === "warmup" ? "Warm Up" : section.key === "cooldown" ? "Cool Down" : "Main" }} Exercise
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="dateList.length === 0" class="empty-state-container">
          <mat-icon class="empty-state-icon">event_note</mat-icon>
          <h5 class="empty-state-title">No Dates Selected</h5>
          <p class="empty-state-text">
            Please select a date range in Step 1 to view the schedule.
          </p>
        </div>
      </div>
    </div>

    <!-- Step 3: Success -->
    <div *ngIf="currentStep === 3" class="activeTabContent">
      <div class="success-step-container">
        <div class="success-content">
          <div class="success-icon-container">
            <mat-icon class="success-icon-large">check_circle</mat-icon>
          </div>
          <h2 class="success-title">Fitness Plan Assigned</h2>
          <p class="success-message">
            The Fitness Plan has been assigned to the member and will be
            notified within a short period of time
          </p>
          <button
            class="btn btn-success success-continue-btn"
            (click)="onSuccessStepContinue()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Submission Loader Overlay -->
<div class="submission-overlay" *ngIf="isSubmitting">
  <div class="submitting-container">
    <div class="spinner"></div>
    <div class="submitting-text">Assigning Fitness Plan...</div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div
  class="modal fade show modal-overlay"
  *ngIf="showDeleteConfirmation"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteConfirmationModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-styled">
        <h5
          class="modal-title modal-title-delete"
          id="deleteConfirmationModalLabel"
        >
          <mat-icon class="modal-icon">warning</mat-icon>
          Confirm Delete
        </h5>
      </div>
      <div class="modal-body modal-body-styled">
        <p class="modal-body-text">
          {{ deleteConfirmationMessage }}
        </p>
      </div>
      <div class="modal-footer modal-footer-styled">
        <button
          type="button"
          class="btn btn-secondary modal-btn-cancel"
          (click)="cancelDelete()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-danger modal-btn-delete"
          (click)="confirmDelete()"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Validation Error Modal -->
<div
  class="modal fade show modal-overlay"
  *ngIf="showValidationErrors"
  tabindex="-1"
  role="dialog"
  aria-labelledby="validationErrorModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-styled">
        <h5
          class="modal-title modal-title-validation"
          id="validationErrorModalLabel"
        >
          <mat-icon class="modal-icon">error</mat-icon>
          Validation Errors
        </h5>
      </div>
      <div class="modal-body modal-body-styled">
        <p class="validation-description">
          Please fix the following issues before proceeding:
        </p>
        <div class="validation-list-container">
          <ul class="validation-list">
            <li
              *ngFor="let error of validationErrors"
              class="validation-error-item"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer modal-footer-styled">
        <button
          type="button"
          class="btn btn-primary modal-btn-primary"
          (click)="closeValidationErrors()"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Empty Dates Warning Modal -->
<div
  class="modal fade show modal-overlay"
  *ngIf="showEmptyDatesWarning"
  tabindex="-1"
  role="dialog"
  aria-labelledby="emptyDatesWarningModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-styled">
        <h5
          class="modal-title modal-title-warning"
          id="emptyDatesWarningModalLabel"
        >
          <mat-icon class="modal-icon">warning</mat-icon>
          Empty Workout Dates Found
        </h5>
      </div>
      <div class="modal-body modal-body-styled">
        <p class="modal-body-text">
          Your fitness plan contains <strong>{{ emptyDatesCount }}</strong>
          {{ emptyDatesCount === 1 ? "date" : "dates" }} with no exercises
          configured.
        </p>
        <p class="modal-body-text">You can either:</p>
        <ul class="modal-options-list">
          <li>Go back and add exercises to these dates, or</li>
          <li>
            Continue with the submission (empty dates will remain as workout
            days without exercises)
          </li>
        </ul>
        <p class="modal-body-text">
          <em>Note: Rest days are not included in this count.</em>
        </p>
      </div>
      <div class="modal-footer modal-footer-styled">
        <button
          type="button"
          class="btn btn-secondary modal-btn-cancel"
          (click)="cancelEmptyDatesSubmission()"
        >
          Go Back & Add Exercises
        </button>
        <button
          type="button"
          class="btn btn-primary modal-btn-primary"
          (click)="confirmEmptyDatesSubmission()"
        >
          Continue Anyway
        </button>
      </div>
    </div>
  </div>
</div>

<!-- No Dates To Update Warning Modal -->
<div
  class="modal fade show modal-overlay"
  *ngIf="showNoDatesToUpdateWarning"
  tabindex="-1"
  role="dialog"
  aria-labelledby="noDatesToUpdateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-styled">
        <h5
          class="modal-title modal-title-warning"
          id="noDatesToUpdateModalLabel"
        >
          <mat-icon class="modal-icon">info</mat-icon>
          No Dates to Update
        </h5>
      </div>
      <div class="modal-body modal-body-styled">
        <p class="modal-body-text">
          All dates in the selected range are in the past. There are no current
          or future dates to update.
        </p>
        <p class="modal-body-text">
          Please select a date range that includes current or future dates to
          create or update a fitness plan.
        </p>
      </div>
      <div class="modal-footer modal-footer-styled">
        <button
          type="button"
          class="btn btn-primary modal-btn-primary"
          (click)="dismissNoDatesToUpdateWarning()"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Confirmation Modal -->
<div
  class="modal fade show modal-overlay"
  *ngIf="showBulkDeleteConfirmation"
  tabindex="-1"
  role="dialog"
  aria-labelledby="bulkDeleteConfirmationModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-styled">
        <h5
          class="modal-title modal-title-delete"
          id="bulkDeleteConfirmationModalLabel"
        >
          <mat-icon class="modal-icon">warning</mat-icon>
          Confirm Exercise Deletions
        </h5>
      </div>
      <div class="modal-body modal-body-styled">
        <p class="modal-body-text">
          You have marked <strong>{{ bulkDeleteCount }}</strong>
          {{ bulkDeleteCount === 1 ? "exercise" : "exercises" }} for deletion.
        </p>
        <p class="modal-body-text">
          The following exercises will be permanently deleted:
        </p>
        <div class="deletion-list-container">
          <ul class="deletion-list">
            <li
              *ngFor="let item of getPendingDeletionExercises()"
              class="deletion-list-item"
            >
              <strong>{{ item.date }}:</strong> {{ item.exercise }}
            </li>
          </ul>
        </div>
        <p class="modal-body-text">
          <em
            >This action cannot be undone. Are you sure you want to proceed?</em
          >
        </p>
      </div>
      <div class="modal-footer modal-footer-styled">
        <button
          type="button"
          class="btn btn-secondary modal-btn-cancel"
          (click)="cancelBulkDeletion()"
        >
          Cancel & Review
        </button>
        <button
          type="button"
          class="btn btn-danger modal-btn-delete"
          (click)="confirmBulkDeletion()"
        >
          Delete All & Save
        </button>
      </div>
    </div>
  </div>
</div>
